// extracted by mini-css-extract-plugin
module.exports =  {"button":"a10a3f92e9--button--OG_GQ","dark":"a10a3f92e9--dark--sPwzU"};